module.exports = __webpack_public_path__ + "img/ticket.e4144bb3.png";